import {Component, Input, OnInit} from "@angular/core";
import {DialogComponent} from '../../../../../../ng2-bootstrap-modal/dialog.component';
import {DialogService} from '../../../../../../ng2-bootstrap-modal/dialog.service';
import {FormControl, FormGroup, Validators} from "@angular/forms";

@Component({
    selector: 'db-txt-content-dns-dialog',
    templateUrl: './txt-content-dns-dialog.component.html',
    styleUrls: ['./txt-content-dns-dialog.component.scss'],
    standalone: false
})
export class TxtContentDnsDialogComponent extends DialogComponent<null, any> implements OnInit {
  @Input() txtContent: any;
  @Input() fromType: any;

  public loading: boolean;
  public changes: any;
  public TxtContent: FormGroup;
  public formSubmitted: boolean = false;
  public placeholder: string;

  constructor(
    private _dialogService: DialogService
  ) {
    super(
      _dialogService
    );

  }

  ngOnInit() {
    switch (this.fromType) {
      case 'MX':
        this.placeholder = "Format: \n" +
          "    [priority] [mail server host name] \n" +
          "Example: \n" +
          "    10 mailserver.example.com. \n" +
          "    20 mailserver2.example.com.";
        break;

      case 'SRV':
        this.placeholder = "Format: \n" +
          "    [priority] [weight] [port] [server host name]\n" +
          "Example: \n" +
          "    1 10 5269 xmpp-server.example.com. \n" +
          "    2 12 5060 sip-server.example.com.";
        break;

      case 'TXT':
        this.placeholder = "Example: \n" + "    Text 1" + "\n" + "    Text 2";
        break;

      default:
        this.placeholder = "";
    }
    this.TxtContent = new FormGroup({
      'text': new FormControl(this.txtContent.text ? this.txtContent.text : '', [Validators.required])
    });
  }

  public close_window(): void {
    this.close();
  }


  public confirm(): void {
    this.loading = true;
    this.formSubmitted = true;
    if (this.TxtContent.valid) {
      this.result = this.TxtContent.value;
      this.close();
    }
  }

}
